(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/base.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/base.js');

'use strict';

class DialogBase {
  constructor(_ref) {
    let {
      onConfirm = () => {},
      onCancel = () => {},
      syndicate
    } = _ref;
    this.onConfirm = onConfirm;
    this.onCancel = onCancel;
    this.syndicate = syndicate;
  }
  show() {
    svs.components.dialog.api.add(new svs.components.dialog.Confirm(this.createProps()));
  }
  createProps() {
    return {
      branding: svs.components.dialog.branding.TUR,
      type: this.getType(),
      icon: this.getIcon(),
      title: this.getTitle(),
      message: this.getMessage(),
      actions: this.getActions()
    };
  }
  getAccountOwner() {
    if (this.syndicate && this.syndicate.syndicateName) {
      return svs.tur.payment.utils.misc.addOwningGrammarApostrophe(this.syndicate.syndicateName);
    }
    return 'Ditt';
  }

  getType() {
    return svs.components.dialog.type.INFO;
  }
  getIcon() {
    return 'games';
  }
  getTitle() {
    return '';
  }
  getMessage() {
    return [];
  }
  getActions() {
    return [];
  }
}
svs.tur.payment.dialogs.DialogBase = DialogBase;

 })(window);